
import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { getAllCookies, TOKEN, USER_ID, getIsNpiAdmin, getIsAdmin } from 'Lib'
import { getIsAccessMyCarReservation, getIsAccessMyTracker, getIsAccessMyTraining, getIsAdminTraining } from '../../lib'

const Auth = {
	isAuthenticated: () => {
		const cookies = getAllCookies()
		let isAuth = false

		if (cookies && cookies[TOKEN] && cookies[USER_ID]) {
			isAuth = true
		}
		return isAuth
	},
	isNpiAdmin: () => {
		const isAdmin = getIsNpiAdmin()
		return isAdmin.toString() === "true"
	},
	isAdmin: () => {
		const isAdmin = getIsAdmin()
		return isAdmin.toString() === "true"
	},
	isAdminTraining: () => {
		const isAdminTraining = getIsAdminTraining()
		return isAdminTraining.toString() === "true"
	},
	isAdminCarReservation: () => {
		const isAdminCarReservation = getIsAccessMyCarReservation()
		// return isAdminCarReservation.toString() === "true"
		return true
	},
	isAccessMyTracker: () => {
		const isAdminTraining = getIsAccessMyTracker()
		// return isAdminTraining.toString() === "true"
		return true
	},
	isAccessMyTraining: () => {
		const isAccessMyTraining = getIsAccessMyTraining()
		// return isAccessMyTraining.toString() === "true"
		return true
	},
	isAccessMyCarReservation: () => {
		const isAccessMyCarReservation = getIsAccessMyCarReservation()
		// return isAccessMyCarReservation.toString() === "true"
		return true
	},
}

const MyTrackerPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && Auth.isAccessMyTracker ===false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const MyTrainingPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && Auth.isAccessMyTraining ===false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const MyCarReservationPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && Auth.isAccessMyCarReservation === false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)


const AdminCarReservationPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === true && Auth.isAdminCarReservation() === false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const AdminTrainingPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === true && Auth.isAdminTraining() === false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const AdminPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === true && Auth.isAdmin() === false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const NPIPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === true && Auth.isNpiAdmin() === false && props.match.url !== "/login") {
			return <Redirect to='/unauthen' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const PrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			return <Redirect to='/login' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return <Redirect to='/' />
			}
		}
	}} />
)

const PublicRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Layout) {
			return <Layout {...props} Component={Component} />
		} else {
			if (Component !== undefined) {
				return <Component {...props} />
			} else {
				return null
			}
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	NPIPrivateRoute,
	AdminPrivateRoute,
	AdminTrainingPrivateRoute,
	MyTrackerPrivateRoute,
	MyTrainingPrivateRoute,
	MyCarReservationPrivateRoute,
	AdminCarReservationPrivateRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/app/routes/routePermission.js